module.exports = __webpack_public_path__ + "static/media/ShardMeetingRoom7.486aff0f.jpg";